"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _moment = _interopRequireDefault(require("moment"));

var _getRushValue = _interopRequireDefault(require("./getRushValue"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function dueDateDiffFrom(onHoldDate) {
  if (onHoldDate) {
    var momentOnHoldDate = (0, _moment.default)(onHoldDate);
    return momentOnHoldDate.isValid() ? momentOnHoldDate : (0, _moment.default)(parseInt(onHoldDate, 10));
  }

  return (0, _moment.default)();
}

var _default = (0, _memoizeOne.default)(function (_ref) {
  var dueDate = _ref.dueDate,
      RUSH_EDIT = _ref.RUSH_EDIT,
      onHoldDate = _ref.onHoldDate;

  if (!dueDate) {
    return {};
  }

  var momentDueDate = (0, _moment.default)(dueDate);
  var parsedDueDate = momentDueDate.isValid() ? momentDueDate : (0, _moment.default)(parseInt(dueDate, 10));
  var hoursTotal = (0, _getRushValue.default)(RUSH_EDIT);
  var hoursDiff = parsedDueDate.diff(dueDateDiffFrom(onHoldDate), 'hours');
  var hoursLeft = Math.max(hoursDiff, 0);
  return {
    hoursLeft: hoursLeft,
    hoursTotal: hoursTotal,
    percentageComplete: "".concat((hoursTotal - hoursLeft) / hoursTotal * 100, "%")
  };
});

exports.default = _default;